<template>
  <div class="a-mac">
    <hr />
    <h1>Default macro-form-section</h1>
    <macro-component
      style="display: inline-block"
      route="/"
      :setTargetThisRefence="getThisReference"
    />
    <hr />
    <h1>macro-filter-section</h1>
    <macro-component
      style="display: inline-block"
      view="macro-filter-section"
      route="/customer-relationship/client"
      :setTargetThisRefence="getThisReference"
      reference="pedet"
    />

    <hr />
    <h1>macro-navigation-section</h1>
    <macro-component
      style="display: inline-block"
      view="macro-navigation-section"
      route="/customer-relationship/client_account"
      :setTargetThisRefence="getThisReference"
      reference="pedet"
    />
  </div>
</template>

<script>
export default {
  name: "macro-example",
};
</script>

<style scoped>
.a-mac {
  background-color: #80afd8;
  padding: 20px;
  margin: 10px;
}
</style>